// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3Z4Yx","subheader":"ReorderModal_subheader__TEhjA","listWrap":"ReorderModal_listWrap__3YaIH"};